import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

export const connectPrivateWebsocketThunk = createAsyncThunk(
  'chat/connectPrivateWebsocket',
  async ({ chatWebsocketRef, userId }, { getState }) => {
    const socketValidObject = {
      newUserConnection: {
        id: v4(),
        userId,
        isActive: true,
      },
    };
    chatWebsocketRef.current.send(JSON.stringify(socketValidObject));
  }
);
